import { useRef } from 'react';

const STORAGE_KEY = '__MAGRITTE_DOM_STORAGE__';
const storeValueInDom = (key, value) => {
    if (typeof window === 'undefined') {
        return;
    }
    const storage = window[STORAGE_KEY] || {};
    storage[key] = value;
    window[STORAGE_KEY] = storage;
};
const getValueFromDom = (key) => {
    if (typeof window === 'undefined') {
        return undefined;
    }
    const storage = window[STORAGE_KEY] || {};
    return storage[key];
};
const removeValueFromDom = (key) => {
    if (typeof window === 'undefined') {
        return;
    }
    const storage = window[STORAGE_KEY] || {};
    delete storage[key];
    window[STORAGE_KEY] = storage;
};
const UNIQUIE_ID_STORAGE = '_MAGRITTE_UNIQUE_ID_';
storeValueInDom(UNIQUIE_ID_STORAGE, 0);
const useDomStoredUniqueId = () => {
    const currentId = useRef(-1);
    if (currentId.current === -1) {
        const id = getValueFromDom(UNIQUIE_ID_STORAGE);
        if (id === undefined) {
            currentId.current = -1;
        }
        else {
            currentId.current = id + 1;
        }
        storeValueInDom(UNIQUIE_ID_STORAGE, currentId.current);
    }
    return currentId.current.toString();
};

export { getValueFromDom, removeValueFromDom, storeValueInDom, useDomStoredUniqueId };
//# sourceMappingURL=index.js.map
